export default __webpack_public_path__ + "static/media/training-illustration10.050e715d.png";